import toggleModal from '@/scripts/utils/toggle-modal';
import swiperSliderInit from '@/scripts/blocks/swiper-slider';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd';
import _debounce from 'lodash/debounce';
import { DOCUMENT_ELEMENT, KEY_CODES } from '@/scripts/constants';
import transitionend from '@/scripts/utils/transitionend';
import './GalleryModal.scss';

const defaults = {
  triggerElements: null,
};

export default class GalleryModal {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.triggerElements = options.triggerElements;
    if (!this.triggerElements) return;

    this.$modal = $('[data-role*="gallery-modal-element"]');
    this.$modalSlidesContainer = this.$modal.find('[data-role="slides-container"]');
    this.$top = this.$modal.find('[data-role*="modal-top"]');
    this.$main = this.$modal.find('[data-role*="modal-main"]');
    this.$bot = this.$modal.find('[data-role*="modal-bot"]');
    this.$close = this.$modal.find('[data-role*="modal-close"]');
    this.slider = null;

    this.activeClass = 'gallery-modal-opened';
    this.loadingClass = 'is-loading';
    this.init();
  }

  toggleStatus(flag) {
    DOCUMENT_ELEMENT.classList.toggle(this.activeClass, flag);
    return toggleModal(flag, null, this.$modal[0]);
  }

  get active() {
    return DOCUMENT_ELEMENT.classList.contains(this.activeClass);
  }

  initSlider(el) {
    const { params, title } = el.dataset;
    const { type, url, data } = JSON.parse(params);
    this.$modal.addClass(this.loadingClass);
    $.ajax({
      type,
      url,
      data,
      success: (result) => {
        this.$modalSlidesContainer.append(result);
        this.slider = swiperSliderInit({
          swiperTitle: title,
          slidesPerView: 1,
          spaceBetween: 30,
          speed: 1000,
          pagination: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          selector: 'modal-gallery',
        })[0].dom7ElementDataStorage.swiper;
        this.resize();
        imagesLoaded(this.$modal[0], () => {
          this.resize();
          this.$modal.removeClass(this.loadingClass);
        });
      },
    });
  }

  destroySlider() {
    transitionend(this.$modal[0], 'transitionend', () => {
      this.slider.destroy();
      this.$modalSlidesContainer.children().remove();
    });
  }

  resize() {
    this.$main.css({
      height: window.innerHeight - this.$top.height() - this.$bot.height(),
    });
  }

  init() {
    window.addEventListener('resize', _debounce(() => this.resize(), 50));
    this.triggerElements.forEach(trigger => trigger.addEventListener('click', (e) => {
      if (e) e.preventDefault();
      this.initSlider(trigger);
      return this.toggleStatus(true);
    }));
    this.$close.on('click', () => {
      this.destroySlider();
      return this.toggleStatus(false);
    });
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === KEY_CODES.ESC && this.active) {
        this.destroySlider();
        this.toggleStatus(false);
      }
    });
    this.resize();
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/GalleryModal/GalleryModal.js